import type { FieldErrors } from 'react-hook-form';
import type { FormValidationError } from '../../../utils/formValidation';
import type { OpportunityRequestDetailsRhfValues } from '../../../validation/opportunityProjectFieldsSchema';
import type { SubsectionFieldDescriptor } from '../../../utils/subsectionHeaderMetrics';
import {
  OPPORTUNITY_DEAL_REGISTRATION_SUBSECTION_FIELDS,
  OPPORTUNITY_NOTES_SUBSECTION_FIELDS,
  OPPORTUNITY_PROJECT_SUMMARY_SUBSECTION_FIELDS,
  OPPORTUNITY_REQUESTOR_SUBSECTION_FIELDS,
  OPPORTUNITY_SCALE_TIMELINE_SUBSECTION_FIELDS,
  OPPORTUNITY_TEAM_SUBSECTION_FIELDS,
  OPPORTUNITY_DEAL_REGISTRATION_FIELD_KEYS,
  OPPORTUNITY_NOTES_FIELD_KEYS,
  OPPORTUNITY_PROJECT_SUMMARY_FIELD_KEYS,
  OPPORTUNITY_REQUESTOR_FIELD_KEYS,
  OPPORTUNITY_SCALE_TIMELINE_FIELD_KEYS,
  OPPORTUNITY_TEAM_FIELD_KEYS,
} from '../../../request/fields/requestFieldRegistry';

export function subsectionDescriptorKeys(
  descriptors: readonly SubsectionFieldDescriptor[],
): readonly string[] {
  return descriptors.map((d) => d.key);
}

export {
  OPPORTUNITY_REQUESTOR_FIELD_KEYS,
  OPPORTUNITY_PROJECT_SUMMARY_FIELD_KEYS,
  OPPORTUNITY_DEAL_REGISTRATION_FIELD_KEYS,
  OPPORTUNITY_SCALE_TIMELINE_FIELD_KEYS,
  OPPORTUNITY_NOTES_FIELD_KEYS,
  OPPORTUNITY_TEAM_FIELD_KEYS,
};

/** Auto-expand a collapsed subsection card when parent or RHF validation targets a field in that card (#1011). */
export function opportunitySubsectionShouldExpand(
  fields: readonly string[],
  validationErrors: FormValidationError[],
  rhfErrors: FieldErrors<OpportunityRequestDetailsRhfValues> = {},
): boolean {
  if (validationErrors.some((e) => fields.includes(e.field))) {
    return true;
  }
  return fields.some((field) => {
    const err = rhfErrors[field as keyof OpportunityRequestDetailsRhfValues];
    if (err == null) {
      return false;
    }
    if (typeof err.message === 'string') {
      return err.message.length > 0;
    }
    return true;
  });
}

export {
  OPPORTUNITY_DEAL_REGISTRATION_SUBSECTION_FIELDS,
  OPPORTUNITY_NOTES_SUBSECTION_FIELDS,
  OPPORTUNITY_PROJECT_SUMMARY_SUBSECTION_FIELDS,
  OPPORTUNITY_REQUESTOR_SUBSECTION_FIELDS,
  OPPORTUNITY_SCALE_TIMELINE_SUBSECTION_FIELDS,
  OPPORTUNITY_TEAM_SUBSECTION_FIELDS,
};
